const topics = [
  { name: '顶流争议', count: '128.6万', hot: true },
  { name: '综艺录制', count: '96.3万', hot: true },
  { name: '新专辑预告', count: '85.7万', hot: true },
  { name: '影视大结局', count: '72.1万', hot: false },
  { name: '体育名场面', count: '68.4万', hot: false },
  { name: '品牌代言', count: '55.9万', hot: false },
  { name: '剧组内幕', count: '43.2万', hot: true },
  { name: '算法更新', count: '38.5万', hot: false },
  { name: '音乐节阵容', count: '31.8万', hot: false },
];

const rankingItems = [
  { rank: 1, title: '顶流艺人深夜回应争议：真相究竟如何？', views: '328万', trend: 'up', change: '+45%' },
  { rank: 2, title: '综艺节目录制意外：工作人员还原现场', views: '286万', trend: 'up', change: '+32%' },
  { rank: 3, title: '知名音乐人新专辑：曲目列表独家曝光', views: '241万', trend: 'up', change: '+28%' },
  { rank: 4, title: '热播剧大结局收视率破纪录：观众反应两极', views: '198万', trend: 'down', change: '-12%' },
  { rank: 5, title: '体育赛事直播花絮：意外走红社交媒体', views: '165万', trend: 'up', change: '+18%' },
  { rank: 6, title: '品牌代言更迭：多位艺人竞争同一席位', views: '132万', trend: 'up', change: '+8%' },
];

const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20coral%20red%20abstract%20editorial%20design%20with%20soft%20gradient%20washes%20and%20delicate%20organic%20shapes%2C%20modern%20minimalist%20composition%2C%20clean%20sophisticated%20aesthetic%2C%20warm%20ambient%20lighting%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-01-51hl&orientation=landscape',
    tag: '独家',
    tagColor: 'bg-primary-500',
    title: '某知名剧组内部矛盾升级，多位主创关系微妙',
    desc: '据多位知情人士透露，近期热门剧组内部出现严重分歧，可能影响后续拍摄计划。',
    time: '3小时前',
    reads: '12.8万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20golden%20amber%20abstract%20editorial%20composition%20with%20flowing%20gradients%20and%20soft%20curves%2C%20elegant%20modern%20design%2C%20luxurious%20warm%20tones%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-02-51hl&orientation=landscape',
    tag: '热议',
    tagColor: 'bg-accent-500',
    title: '社交媒体热议：算法调整后内容生态将如何变化',
    desc: '平台算法更新引发创作者圈广泛讨论，多位头部博主发声表达关切。',
    time: '5小时前',
    reads: '9.6万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20soft%20editorial%20abstract%20design%20with%20coral%20and%20cream%20gradients%2C%20delicate%20organic%20shapes%2C%20refined%20magazine%20aesthetic%2C%20clean%20composition%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-03-51hl&orientation=landscape',
    tag: '追踪',
    tagColor: 'bg-secondary-500',
    title: '综艺节目背后：那些不为人知的制作故事',
    desc: '深度探访热门综艺的制作流程，揭秘荧幕背后的真实面貌。',
    time: '7小时前',
    reads: '8.3万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20elegant%20abstract%20editorial%20composition%20with%20coral%20red%20gradient%20washes%2C%20minimalist%20modern%20design%2C%20sophisticated%20warm%20aesthetic%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-04-51hl&orientation=landscape',
    tag: '独家',
    tagColor: 'bg-primary-500',
    title: '下半年娱乐大事件预测：这些瓜值得期待',
    desc: '综合行业动态与内部消息，盘点未来数月最可能引爆全网的话题。',
    time: '9小时前',
    reads: '7.1万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20amber%20abstract%20editorial%20design%20with%20soft%20flowing%20gradients%2C%20delicate%20modern%20composition%2C%20elegant%20warm%20tones%2C%20sophisticated%20visual%20aesthetic%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-05-51hl&orientation=landscape',
    tag: '盘点',
    tagColor: 'bg-accent-500',
    title: '音乐节季来临：全国各大音乐节阵容对比',
    desc: '为你整理今夏最值得关注的音乐节信息，提前规划你的音乐之旅。',
    time: '11小时前',
    reads: '6.5万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20coral%20abstract%20editorial%20composition%20with%20soft%20gradients%20and%20organic%20curves%2C%20clean%20modern%20design%2C%20sophisticated%20warm%20lighting%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=card-06-51hl&orientation=landscape',
    tag: '解读',
    tagColor: 'bg-secondary-500',
    title: '体育圈转会季：重磅交易背后的商业逻辑',
    desc: '深度分析近期体育圈转会动态，解读背后复杂的商业运作。',
    time: '13小时前',
    reads: '5.8万',
  },
];

const getRankColor = (rank: number) => {
  if (rank === 1) return 'text-primary-500';
  if (rank === 2) return 'text-accent-500';
  if (rank === 3) return 'text-secondary-500';
  return 'text-foreground-400';
};

const getRankBg = (rank: number) => {
  if (rank === 1) return 'bg-primary-100';
  if (rank === 2) return 'bg-accent-100';
  if (rank === 3) return 'bg-secondary-100';
  return 'bg-background-200';
};

export default function SectionGroupB() {
  return (
    <>
      <section id="topics" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-primary-500"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">话题热榜</h2>
            <span className="text-xs text-foreground-400 ml-2">实时热度</span>
          </div>
          <div className="flex flex-wrap gap-3">
            {topics.map((item, i) => (
              <div
                key={i}
                className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-colors cursor-pointer"
              >
                <span className={`text-xs font-bold ${item.hot ? 'text-primary-500' : 'text-foreground-500'}`}>
                  {i + 1}
                </span>
                <span className="text-sm font-medium text-foreground-800">{item.name}</span>
                <span className="text-[11px] text-foreground-400">{item.count}</span>
                {item.hot && (
                  <i className="ri-fire-line text-primary-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="ranking" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-accent-500"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">吃瓜排行</h2>
            <span className="text-xs text-foreground-400 ml-2">热度榜单</span>
          </div>
          <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, i) => (
              <div
                key={i}
                className={`flex items-center gap-4 p-4 md:p-5 ${
                  i < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
                } hover:bg-background-50 transition-colors cursor-pointer`}
              >
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm ${getRankBg(item.rank)} ${getRankColor(item.rank)}`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm md:text-base text-foreground-800 font-medium truncate">{item.title}</div>
                </div>
                <div className="text-xs text-foreground-400 whitespace-nowrap">{item.views}</div>
                <div className={`text-xs font-medium whitespace-nowrap ${item.trend === 'up' ? 'text-primary-500' : 'text-foreground-500'}`}>
                  {item.change}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="cards" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-primary-500"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门爆料</h2>
            <span className="text-xs text-foreground-400 ml-2">精选内容</span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.map((item, i) => (
              <div key={i} className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 group cursor-pointer">
                <div className="relative aspect-[3/2] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3">
                    <span className={`px-2.5 py-1 rounded-full ${item.tagColor} text-white text-[10px] font-medium`}>{item.tag}</span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">{item.desc}</p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{item.time}</span>
                    <span>{item.reads} 阅读</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}